import {
    Typography,
    RadioGroup,
    FormControl,
    FormLabel,
    FormControlLabel,
    Radio,
    Stack,
} from '@mui/material'
// import Grid2 from '@mui/material/Unstable_Grid2/Grid2'
import React from 'react'
import { Item } from './Item.js'

export default function GglRow({
    handleInputChange,
    handleValue,
    unitPreferred,
    perimeterInPreferredUnits,
    acre,
    validLength,
}) {
    const id = 'measure'
    const name = 'unit'
    const paramKey = 'unit'

    let show = validLength ? 'none' : 'block'
    let color = validLength ? 'black' : 'red'

    return (
        <>
            <Stack
                direction={'row'}
                sx={{
                    // display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Stack>
                    <Item elevation={0} sx={{ py: 0 }}>
                        <FormControl
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            <FormLabel
                                id="radio-buttons-group-label"
                                sx={{
                                    paddingRight: 0,
                                    mr: 2,
                                }}
                            >
                                <Typography
                                    align="left"
                                    variant="subtitle1"
                                    sx={{ fontWeight: 600 }}
                                >
                                    Preferred units
                                </Typography>
                            </FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="radio-buttons-group-label"
                                id={id}
                                name={name}
                                onChange={(e) =>
                                    handleInputChange(e, { paramKey })
                                }
                                value={handleValue(paramKey, '')}
                                // sx={{
                                //     '& span.MuiButtonBase-root.MuiRadio-root': {
                                //         color: 'black',
                                //         // paddingTop: { xs: '0px', sm: '9px' },
                                //     },
                                // }}
                            >
                                <FormControlLabel
                                    value={'feet'}
                                    control={<Radio />}
                                    label={'feet'}
                                />
                                <FormControlLabel
                                    value={'meters'}
                                    control={<Radio />}
                                    label={'meters'}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Item>
                </Stack>
                <Stack
                // direction={'row'}
                // sx={
                //     {
                //         // justifyContent: 'end',
                //         // alignItems: 'center',
                //     }
                // }
                >
                    <Item
                    // elevation={0}
                    // sx={{
                    //     py: 0,

                    //     display: 'flex',
                    //     justifyContent: 'end',
                    //     alignContent: 'center',
                    // }}
                    >
                        <Stack direction={'row'}>
                            <Typography
                                // align="right"
                                variant="subtitle1"
                                sx={{ fontWeight: 500, color: color }}
                            >
                                {`${unitPreferred}: ${perimeterInPreferredUnits}    `}
                            </Typography>

                            <Typography
                                // align="right"
                                variant="subtitle1"
                                sx={{
                                    fontWeight: 500,
                                    ml: { xs: '1.5rem', sm: '3rem' },
                                }}
                                // sx={{ fontWeight: 500, ml: { sm: '3rem' } }}
                            >
                                {`Acres:  ${acre}`}
                            </Typography>
                        </Stack>
                    </Item>
                </Stack>
            </Stack>
            <Stack sx={{ pt: 0, display: show }}>
                <Typography
                    variant="subtitle2"
                    sx={{ color: 'red', textAlign: 'right', mr: 2 }}
                >
                    Warning - The fence length seems too long.
                </Typography>
            </Stack>
        </>
    )
}
